"use client";

import ErrorComponent from "@components/error";

export default function MakeAnOfferError() {
  return (
    <ErrorComponent
      message={"product-not-available"}
      backMessage={"new-search"}
      url={"/search"}
    />
  );
}
